module.exports = __webpack_public_path__ + "img/advisory-icon.9a569db9.svg";